(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toth-itinerario"] && !Shopify.designMode) return;
  try {
    
  class TothItinerary extends HTMLElement {
    #timer = null;
    #index = 0;
    #paused = false;
    #visible = false;
    #reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    connectedCallback() {
      this.rows = [...this.querySelectorAll('[data-ti-row]')];
      this.panels = [...this.querySelectorAll('[data-ti-panel]')];
      this.counter = this.querySelector('[data-ti-current]');
      if (this.rows.length === 0) return;

      this.autoplay = this.dataset.autoplay === 'true' && !this.#reducedMotion.matches;
      this.interval = (Number(this.dataset.interval) || 6) * 1000;
      if (this.dataset.monoLogos === 'true') this.setAttribute('data-mono', '');

      for (const row of this.rows) {
        row.addEventListener('click', () => this.#select(Number(row.dataset.index), true));
      }
      this.querySelector('[data-ti-prev]')?.addEventListener('click', () => this.#step(-1, true));
      this.querySelector('[data-ti-next]')?.addEventListener('click', () => this.#step(1, true));

      this.addEventListener('keydown', this.#onKeydown.bind(this));
      this.addEventListener('pointerenter', () => this.#setPaused(true));
      this.addEventListener('pointerleave', () => this.#setPaused(false));
      this.addEventListener('focusin', () => this.#setPaused(true));
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.#setPaused(false);
      });
      document.addEventListener('visibilitychange', () => this.#syncTimer());

      this.#observer = new IntersectionObserver(
        (entries) => {
          this.#visible = entries[0].isIntersecting;
          this.#syncTimer();
        },
        { threshold: 0.35 }
      );
      this.#observer.observe(this);

      this.#markNextStop();
      this.#select(0, false);
    }

    disconnectedCallback() {
      this.#stop();
      this.#observer?.disconnect();
    }

    #onKeydown(event) {
      const keys = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 };
      if (event.key in keys) {
        event.preventDefault();
        this.#step(keys[event.key], true);
        this.rows[this.#index].focus();
        return;
      }
      if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        this.#select(event.key === 'Home' ? 0 : this.rows.length - 1, true);
        this.rows[this.#index].focus();
      }
    }

    #step(delta, userInitiated) {
      const next = (this.#index + delta + this.rows.length) % this.rows.length;
      this.#select(next, userInitiated);
    }

    #select(index, userInitiated) {
      this.#index = index;

      for (const row of this.rows) {
        const active = Number(row.dataset.index) === index;
        row.classList.toggle('is-active', active);
        row.setAttribute('aria-selected', String(active));
        if (active) row.removeAttribute('tabindex');
        else row.setAttribute('tabindex', '-1');
        if (active) this.#restartProgress(row);
      }

      for (const panel of this.panels) {
        const active = Number(panel.dataset.index) === index;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', String(!active));
      }

      if (this.counter) this.counter.textContent = String(index + 1).padStart(2, '0');
      if (userInitiated) this.#restartTimer();
    }

    #restartProgress(row) {
      const fill = row.querySelector('.toth-itinerary__bar-fill');
      if (!fill) return;
      fill.style.animation = 'none';
      void fill.offsetWidth;
      fill.style.animation = '';
    }

    #markNextStop() {
      const now = new Date().getMonth() + 1;
      let best = null;
      let bestDelta = 13;

      for (const row of this.rows) {
        const month = Number(row.dataset.month);
        if (!month) continue;
        const delta = (month - now + 12) % 12;
        if (delta < bestDelta) {
          bestDelta = delta;
          best = row;
        }
      }

      if (!best) return;
      const badge = best.querySelector('[data-ti-next-badge]');
      if (!badge) return;
      badge.hidden = false;
      if (bestDelta === 0) badge.textContent = 'Este mês';
    }

    #setPaused(value) {
      this.#paused = value;
      this.#syncTimer();
    }

    #syncTimer() {
      const shouldRun =
        this.autoplay && this.#visible && !this.#paused && document.visibilityState === 'visible';
      this.classList.toggle('is-playing', shouldRun);
      if (shouldRun) this.#start();
      else this.#stop();
    }

    #start() {
      if (this.#timer) return;
      this.#restartProgress(this.rows[this.#index]);
      this.#timer = setInterval(() => this.#step(1, false), this.interval);
    }

    #stop() {
      clearInterval(this.#timer);
      this.#timer = null;
    }

    #restartTimer() {
      this.#stop();
      this.#syncTimer();
    }

    #observer = null;
  }

  if (!customElements.get('toth-itinerary')) {
    customElements.define('toth-itinerary', TothItinerary);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toth-legado"] && !Shopify.designMode) return;
  try {
    
  // reveal de entrada — fail-open em tres camadas (inalterado)
  (function(){
    var secs = document.querySelectorAll('.tlg--js');
    for (var i = 0; i < secs.length; i++) (function(sec){
      var alvos = sec.querySelectorAll('.tlg__revela');
      function tudo(){ for (var k = 0; k < alvos.length; k++) alvos[k].classList.add('tlg--vis'); }
      if (!('IntersectionObserver' in window)) { tudo(); return; }
      try {
        var io = new IntersectionObserver(function(ents){
          for (var j = 0; j < ents.length; j++) if (ents[j].isIntersecting) {
            ents[j].target.classList.add('tlg--vis');
            io.unobserve(ents[j].target);
          }
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
        for (var n = 0; n < alvos.length; n++) io.observe(alvos[n]);
        window.setTimeout(tudo, 2600);
      } catch (e) { tudo(); }
    })(secs[i]);
  })();

  // A GALERIA — clique troca; roda sozinha ate a pessoa tocar.
  // Sem rAF/scroll/IO no motor (aba oculta nao trava): setInterval +
  // getBoundingClientRect no tick. Fail-open: pessoa 1 ja vem ligada no HTML.
  (function(){
    var gals = document.querySelectorAll('[data-tlgx]');
    for (var g = 0; g < gals.length; g++) (function(raiz){
      var rostos = raiz.querySelectorAll('.tlgx__rosto');
      if (rostos.length < 2) return;
      var atual = 0, tocou = false;
      function mostra(p){
        atual = p;
        var grupos = [raiz.querySelectorAll('.tlgx__quadro'),
                      raiz.querySelectorAll('.tlgx__painel'),
                      rostos];
        for (var gi = 0; gi < grupos.length; gi++)
          for (var i = 0; i < grupos[gi].length; i++) (function(el){
            var liga = (el.getAttribute('data-p') | 0) === p;
            el.classList.toggle('is-on', liga);
            if (el.getAttribute('role') === 'tab') el.setAttribute('aria-selected', liga ? 'true' : 'false');
            else if (liga) el.removeAttribute('aria-hidden');
            else el.setAttribute('aria-hidden', 'true');
          })(grupos[gi][i]);
      }
      for (var r = 0; r < rostos.length; r++) (function(btn){
        btn.addEventListener('click', function(){
          tocou = true;
          mostra(btn.getAttribute('data-p') | 0);
        });
      })(rostos[r]);
      // SWIPE (ordem do founder: "rolar pro lado"): deslizar no palco troca a pessoa
      var palco = raiz.querySelector('.tlgx__palco');
      if (palco) {
        var x0 = null, y0 = null;
        palco.addEventListener('touchstart', function(ev){
          if (ev.touches.length === 1) { x0 = ev.touches[0].clientX; y0 = ev.touches[0].clientY; }
        }, { passive: true });
        palco.addEventListener('touchend', function(ev){
          if (x0 === null) return;
          var dx = ev.changedTouches[0].clientX - x0;
          var dy = ev.changedTouches[0].clientY - y0;
          x0 = null;
          if (Math.abs(dx) < 42 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
          tocou = true;
          var n = rostos.length;
          mostra(((atual + (dx < 0 ? 1 : -1)) % n + n) % n);
        }, { passive: true });
      }
      window.setInterval(function(){
        if (tocou || document.hidden) return;
        var box = raiz.getBoundingClientRect();
        if (box.bottom < 80 || box.top > window.innerHeight - 80) return;
        mostra((atual + 1) % rostos.length);
      }, 5200);
    })(gals[g]);
  })();

  } catch(e) { console.error(e); }
})();
})();
